import React, { ReactElement, useState } from "react";
import { RiInformationFill } from "react-icons/ri";
import "./Question.css";
import Dialog from "./Dialog";

export function Question({
  title,
  information,
  size,
  showMoreInfo,
}: {
  title: string;
  information: ReactElement;
  size: "small" | "wide" | "xsmall" | "large" | "slide";
  showMoreInfo?: boolean | undefined;
}) {
  const [openInformation, setOpenInformation] = useState(false);

  return (
    <div className="question flex flex-column">
      <div className="title">{title}</div>
      {showMoreInfo ? (
        <>
          <div className="ml-auto flex pointer items-center">
            <RiInformationFill />
            <div
              className="more ml-2"
              onClick={() => {
                setOpenInformation(true);
              }}
            >
              More information
            </div>
          </div>
          <Dialog
            isOpen={openInformation}
            onRequestClose={() => {
              setOpenInformation(false);
            }}
            title={title}
            size={size}
            padding={true}
          >
            {information}
          </Dialog>
        </>
      ) : null}
    </div>
  );
}
